import {eSignConstants} from '../../constants';

const initialState = {
  requestPending: false,
  items: null
};

export function eSignDocuments(state = initialState, action) {
  switch (action.type) {
    case eSignConstants.GET_ESIGN_LIST_REQUEST:
      return {
        ...state,
        requestPending: true
      };
    case eSignConstants.GET_ESIGN_LIST_SUCCESS:
      return {
        ...state,
        items: action.eSignDocuments,
        requestPending: false
      };
    case eSignConstants.GET_ESIGN_LIST_FAILURE:
      return {
        ...state,
        error: action.error,
        requestPending: false
      };
    default:
      return state
  }
}
